import { render, staticRenderFns } from "./CallCenterChart.vue?vue&type=template&id=ec9f0f08&"
import script from "./CallCenterChart.vue?vue&type=script&lang=js&"
export * from "./CallCenterChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports